module.exports = __webpack_public_path__ + "static/9M-2020_2021_Bondholder_Reporting-9c8073c024aa3374b4e6f978dfc8fd6c.pdf";